module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img516-acd76981205a414db4d85bf64c791a94.jpg";